import React from "react";
import { Droppable } from "react-beautiful-dnd";
import Task from "./Task";
function Column(props) {
  const { droppableId, list, type,setTask } = props;
  return (
    <Droppable droppableId={droppableId} type={type}>
      {provided => (
        <div {...provided.droppableProps} ref={provided.innerRef} >
          {list && list.map((val, index) => {
            return (
              <Task setTask={setTask} 
                    id={val._id} 
                    key={val._id} 
                    index={index} 
                    title={val.Category} 
                    images={val.Image}
                    imageName={val.ImageKey} 
                    number={val.Key} 
                    link={val.Url}  
                    color={val.Color}    
             />
            );
          })}

          {provided.placeholder}
        </div>
      )}
    </Droppable>
  );
}

export default Column;